<template>
    <v-dialog :value="show" width="500" @click:outside="$emit('update:show', false)">
        <v-card>
           <v-card-title class="text-h5 primary white--text">
                Exchange Rate
            </v-card-title>

            <v-card-text class="pa-3 pa-lg-5">
                <p class="title mb-0">Before Fee</p>
                <blockquote class="d-flex justify-center pa-3" v-if="order.type === 'p2p' || order.type === 'hybrid'">
                    <div class="mr-3 text-center">
                        <p class="numerator mx-auto mb-0">
                            Recipient Gets
                        </p>
                        Amount
                    </div>

                    <span class="mr-3 mt-3">
                        =
                    </span>

                    <div class="mr-3 text-center">
                        <p class="numerator mx-auto mb-0">
                            {{ posterCurrencySymbol }}{{ formatAmount(order.poster_amount) }}
                        </p>
                        {{ matcherCurrencySymbol }}{{ formatAmount(order.matcher_amount) }}
                    </div>

                    <span class="mr-3 mt-3">
                        =
                    </span>

                    <p class="subtitle-2 mt-3 text-center text-lg-left font-weight-bold mb-0">
                        {{ formatAmount(displayExchangeRate(order).toFixed(4)) }}
                        {{ order.poster_currency }}/{{ order.matcher_currency }}
                    </p>
                </blockquote>

                <blockquote v-else class="text-center pa-3">
                    Exchange Rate: 1 {{ order.matcher_currency }} = {{ order.exchange_rate }} {{ order.poster_currency }}/{{ order.matcher_currency }}
                </blockquote>

                <br />

                <p class="title mb-0">After Fee</p>
                <blockquote class="d-flex justify-center pa-3" v-if="order.type === 'p2p' || order.type === 'hybrid'">
                    <div class="mr-2 text-center">
                        <p class="numerator mx-auto mb-0">
                            Recipient Gets
                        </p>
                        Amount + Fees
                    </div>

                    <span class="mr-2 mt-3">
                        =
                    </span>
                    <div class="mr-2 text-center calculation">
                        <p class="numerator mx-auto mb-0">
                            {{ posterCurrencySymbol }}{{ formatAmount(order.poster_amount) }}
                        </p>

                        <template v-if="order.type === 'p2p'">
                            {{ matcherCurrencySymbol }}({{ formatAmount(order.matcher_amount) }} + 1)
                        </template>
                        <template v-else>
                            {{ matcherCurrencySymbol }}({{ formatAmount(order.matcher_amount) }} + {{ order.matcher_payment_method_fee }} + 1)
                        </template>
                    </div>

                    <span class="mr-2 mt-3">
                        =
                    </span>

                    <p class="subtitle-2 mt-3 text-center text-lg-left font-weight-bold mb-0">
                        {{ formatAmount(order.eer && order.eer.toFixed(4)) }}
                        {{ order.poster_currency }}/{{ order.matcher_currency }}
                    </p>
                </blockquote>

                <blockquote v-else class="text-center pa-3">
                    Exchange Rate: 1 {{ order.matcher_currency }} = {{ order.exchange_rate }} {{ order.poster_currency }}/{{ order.matcher_currency }}
                </blockquote>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="$emit('update:show', false)"
                >
                    I understand
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
let currency = require('../../../modules/currency.js');

export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
        show: Boolean,
    },
    methods: {
        displayExchangeRate(order) {
            if(order.type === '3po') {
                return order.exchange_rate;
            } else {
                return order.poster_amount / order.matcher_amount;
            }
        },
    },
    computed: {
        posterCurrencySymbol() {
            return `${currency.getCurrencySymbol(this.order.poster_currency)}`;
        },
        matcherCurrencySymbol() {
            return `${currency.getCurrencySymbol(this.order.matcher_currency)}`;
        },
    }
}
</script>

<style scoped>
blockquote {
    background-color: #f1f1f1;
}

blockquote div {
    width: 25%;
}

blockquote div.calculation {
    width: 35%;
}

.numerator {
    border-bottom: 1px solid;
}


@media screen and (max-width: 767px) {
    blockquote div {
        width: 100% !important;
    }
}
</style>
